import { Breadcrumbs, Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { useContainer } from 'unstated-next';

import SettingsContainer from './SettingsContainer';
import { SettingsDetailProfile } from './SettingsDetailProfile';
import { PortalProvider } from '../../../PortalContext';
import StyledFormTitle from '../../../styles/form-title';

const Title = styled(StyledFormTitle)`
    margin-bottom: 1rem;
`;

export const SettingsDetail = () => {
    console.log('SettingsDetail');
    const { t } = useTranslation(['portal', 'create_edit_class']);
    const { settingsData } = useContainer(SettingsContainer);

    return (
        <>
            <Grid container justifyContent="space-between">
                <Grid item>
                    <Title>{t('portal:classes-page.settings')}</Title>
                </Grid>
            </Grid>

            <Breadcrumbs aria-label="breadcrumb">
                <Link to="/portal/settings">{t('portal:settings')}</Link>
            </Breadcrumbs>

            {settingsData && (
                <PortalProvider
                    settingsId={settingsData.settings_id as unknown as string}
                    settingsUuid={window.localStorage?.settings_uuid as string}
                >
                    <SettingsDetailProfile />
                </PortalProvider>
            )}
        </>
    );
};
